import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import { APPOINTMENT_NAMESPACE, appointment } from '@/_store/appointment';
import { IAppointment } from '@/_store/types';
import { deepClone } from 'fast-json-patch';
import PropertyCardComponent from '@/components/property-card/PropertyCard.vue';
import moment, { Moment } from 'moment-timezone';

@Component({
  components: {
    PropertyCardComponent
  }
})
export default class OpenAppointment extends Vue {

  @Action('getAppointmentByObjectId', { namespace: APPOINTMENT_NAMESPACE })
  private getAppointmentByObjectId!: (criteria: { objectId: string, key: string }) => Promise<void>;

  @Action('getProperty', { namespace: APPOINTMENT_NAMESPACE })
  private getPropertyAction!: (criteria: { objectId: string, key: string }) => Promise<void>;

  @Action('syncAppointmentClick', { namespace: APPOINTMENT_NAMESPACE })
  private syncAppointmentClick!: (criteria: { id: number }) => void;

  @Getter('getAppointments', { namespace: APPOINTMENT_NAMESPACE })
  private getAppointments!: IAppointment[];

  @Getter('getProperty', { namespace: APPOINTMENT_NAMESPACE })
  private getProperty!: any;

  @Getter('getStatusLoading', { namespace: APPOINTMENT_NAMESPACE })
  private getStatusLoading!: boolean;

  @Getter('getAppointmentClicked', { namespace: APPOINTMENT_NAMESPACE })
  private getAppointmentClicked!: number;

  private appointmentClicked: any = null;
  private selectedDate = null;
  private currentWeek: { appointments: IAppointment[], date: Moment }[] = [];

  public async mounted() {
    const vm = this as any;
    if (vm.$route.query.language) {
      vm.$i18n.locale = vm.$route.query.language;
    } else {
      vm.$i18n.locale = "nl";
    }
    this.selectedDate === null;
    if (vm.$route.query.key && vm.$route.query.objectId) {
      vm.getPropertyAction({ objectId: vm.$route.query.objectId, key: vm.$route.query.key });
      await vm.getAppointmentByObjectId({ objectId: vm.$route.query.objectId, key: vm.$route.query.key });
    }
    vm.gotoWeekExistAppointment();
  }

  get showAllAppointment() {
    if (this.$route.query.showAllAppointment && this.$route.query.showAllAppointment == 'yes') {
      return true;
    }
    return false;
  }

  get buttonBackColor() {
    return '#' + this.$route.query.buttonBackColor || '';
  }

  get buttonFontColor() {
    return '#' + this.$route.query.buttonFontColor || '';
  }

  get isMobileView() {
    const isMobile = this.$route.query.isMobile;
    if (isMobile && isMobile === 'true') {
      return true;
    }
    return false;
  }

  get statusLoading() {
    return this.getStatusLoading;
  }

  get appointments() {
    const appointments = deepClone(this.getAppointments).sort(function (a: any, b: any) {
      // @ts-ignore
      return new Date(a.StartTime) - new Date(b.StartTime);
    });
    return this.handleFilterAppointments({ getall: this.showAllAppointment, appointments: appointments });
  }

  handleFilterAppointments(payload: { getall: boolean, appointments: any[] }) {
    const { getall, appointments } = payload;
    const objectAppoinment: any[] = [];
    return appointments.filter((appointment: any, index: number) => {
      let same = 0;
      let startTimeBeforeItem;
      let ddStartTimeBeforeItem;
      let mmStartTimeBeforeItem;
      let yyyyStartTimeBeforeItem;
      objectAppoinment[index] = appointment;

      if (index > 0) {
        startTimeBeforeItem = new Date(objectAppoinment[index - 1].StartTime);
        ddStartTimeBeforeItem = (startTimeBeforeItem.getDate() < 10 ? '0' : '') + startTimeBeforeItem.getDate();
        mmStartTimeBeforeItem = ((startTimeBeforeItem.getMonth() + 1) < 10 ? '0' : '') + (startTimeBeforeItem.getMonth() + 1);
        yyyyStartTimeBeforeItem = startTimeBeforeItem.getFullYear();
      }

      const startTime = new Date(appointment.StartTime);
      const ddStart = (startTime.getDate() < 10 ? '0' : '') + startTime.getDate();
      const mmStart = ((startTime.getMonth() + 1) < 10 ? '0' : '') + (startTime.getMonth() + 1);
      const yyyyStart = startTime.getFullYear();
      if (index > 0 &&
        ddStartTimeBeforeItem === ddStart &&
        mmStartTimeBeforeItem === mmStart &&
        yyyyStartTimeBeforeItem === yyyyStart &&
        (getall ? objectAppoinment[index - 1].StartTime === appointment.StartTime : 1 == 1)
      ) {
        same = 1;
      }
      if (same === 0) {
        return appointment;
      }
    });
  }

  get disableConfirmButton() {
    if (typeof this.appointmentClicked !== 'undefined' && this.appointmentClicked !== null) {
      return false;
    }
    return true;
  }

  get appointmentClickedTitle() {
    const appointments = deepClone(this.appointments);
    if (appointments.length > 0) {
      return appointments[0].AppointmentPlace;
    }
    return '';
  }

  get appointmentClickedTime() {
    if (typeof this.appointmentClicked !== 'undefined' && this.appointmentClicked) {
      const appointment = deepClone(this.appointmentClicked);
      const startTime = new Date(appointment.StartTime);
      const endTime = new Date(appointment.EndTime);
      appointment.ddStart = (startTime.getDate() < 10 ? '0' : '') + startTime.getDate();
      appointment.mmStart = ((startTime.getMonth() + 1) < 10 ? '0' : '') + (startTime.getMonth() + 1);
      appointment.yyyyStart = startTime.getFullYear();
      appointment.hoursStart = (startTime.getHours() < 10 ? '0' : '') + startTime.getHours();
      appointment.minStart = (startTime.getMinutes() < 10 ? '0' : '') + startTime.getMinutes();
      appointment.hoursEnd = (endTime.getHours() < 10 ? '0' : '') + endTime.getHours();
      appointment.minEnd = (endTime.getMinutes() < 10 ? '0' : '') + endTime.getMinutes();
      const time = `${appointment.ddStart}/${appointment.mmStart}/${appointment.yyyyStart} 
      ${this.$t('CONTACT_APPOINTMENT_FROM')} ${appointment.hoursStart}:${appointment.minStart} 
      ${this.$t('CONTACT_APPOINTMENT_TO')} ${appointment.hoursEnd}:${appointment.minEnd}`;
      return time;
    }
    return '';
  }

  get propertyPrice() {
    let price = '';
    if (this.getProperty) {
      price = this.getProperty.Price.toString();
      price = this.getProperty.ChargesRenter ? `<b>${this.getProperty.Price}</b> + <small>${this.getProperty.ChargesRenter} €</small> ${this.$t('CHARGES')}` : `${price} ‎€`;
      return price;
    }
    return '';
  }

  get propertyPicture() {
    if (this.getProperty) {
      if (this.getProperty.LargePictureItem) {
        return this.getProperty.LargePictureItem.Url;
      }
      if (this.getProperty.MediumPictureItem) {
        return this.getProperty.MediumPictureItem.Url;
      }
      if (this.getProperty.SmallPictureItem) {
        return this.getProperty.SmallPictureItem.Url;
      }
    }
    return '';
  }

  get propertyAddress() {
    return this.getProperty ? this.getAddress(this.getProperty) : '';
  }

  get getCurrentWeekTitle() {
    return this.currentWeek.length > 1 ? `${this.currentWeek[0].date.format("MMM Do")} - ${this.currentWeek[this.currentWeek.length - 1].date.format("MMM Do, YYYY")}` : '';
  }

  public prepareCurrentWeek() {
    this.currentWeek = [];
    let currentDate = moment().locale(this.$i18n.locale);
    let weekStart = currentDate.clone().startOf('isoWeek');
    for (let i = 0; i <= 6; i++) {
      let date = moment(weekStart).locale(this.$i18n.locale).add(i, 'days');
      this.currentWeek.push({
        appointments: this.getListAppointmentByDay(date),
        date: date
      });
    };
  }

  public gotoWeekExistAppointment() {
    if (this.appointments.length > 0) {
      this.currentWeek = [];
      let currentDate = moment(this.appointments[0].StartTime).locale(this.$i18n.locale);
      let weekStart = currentDate.clone().startOf('isoWeek');
      for (let i = 0; i <= 6; i++) {
        let date = moment(weekStart).locale(this.$i18n.locale).add(i, 'days');
        this.currentWeek.push({
          appointments: this.getListAppointmentByDay(date),
          date: date
        });
      };
    } else {
      this.prepareCurrentWeek();
    }
  }

  public getAddress(prop: any) {
    let address: string = '';
    if (prop) {
      if (prop.PublishAddress === true) {
        address += prop.Street + ' ' + prop.HouseNumber;
      }
      if (address !== '') {
        address += ', ';
      }
      address += prop.Zip + ' ' + this.getCityAndCountry(prop.City, prop.CountryID, prop.CountryName);
    }
    return address;
  }

  public getCityAndCountry(city: string, countryID?: number, countryName?: string): string {
    let country = '';
    if (countryID && countryID !== 10) {
      if (countryName) {
        country = ` (${countryName})`;
      }
    }
    return city + country;
  }

  public formatAppointmentButton(appointment: IAppointment) {
    const time = moment(appointment.StartTime).locale(this.$i18n.locale).format('HH:mm');
    return time;
  }

  public handlePreviousWeek() {
    let firstDayOfCurrentWeek = this.currentWeek[0].date;
    let weekStart = firstDayOfCurrentWeek.clone().add(-1, 'days').startOf('isoWeek');
    this.currentWeek = [];
    for (let i = 0; i <= 6; i++) {
      let date = moment(weekStart).locale(this.$i18n.locale).add(i, 'days');
      this.currentWeek.push({
        appointments: this.getListAppointmentByDay(date),
        date: date
      });
    };
  }

  public handleNextWeek() {
    let lastDayOfCurrentWeek = this.currentWeek[this.currentWeek.length - 1].date;
    let weekStart = lastDayOfCurrentWeek.clone().add(1, 'days').startOf('isoWeek');
    this.currentWeek = [];
    for (let i = 0; i <= 6; i++) {
      let date = moment(weekStart).locale(this.$i18n.locale).add(i, 'days');
      this.currentWeek.push({
        appointments: this.getListAppointmentByDay(date),
        date: date
      });
    };
  }

  public getListAppointmentByDay(mo: Moment) {
    const date = mo.format('YYYY/MM/DD');
    const appointments = this.appointments.filter((item: IAppointment) => {
      let appointmentDate = moment(item.StartTime).locale(this.$i18n.locale).format('YYYY/MM/DD');
      if (appointmentDate == date) {
        return item;
      }
    });
    return appointments;
  }

  public handleChooseAppointment(appointment: IAppointment) {
    this.syncAppointmentClick({ id: appointment.AppointmentID });
    this.scrollToElement(1000, 'btn-confirm');
  }

  public scrollToElement(scrollDuration: number, elementId: string) {
    console.log('scrollToElement');
    const vm = this as any;
    const element = document.getElementById(elementId);
    if (element) {
      const y = element.getBoundingClientRect().top + window.scrollY;
      const scrollStep = y / (scrollDuration / 15);
      const scrollInterval = setInterval(function () {
        if (!vm.elementInViewport(element)) {
          window.scrollBy(0, scrollStep);
        } else {
          element.setAttribute('style', 'background-color: yellow');
          setTimeout(function () {
            if (element) {
              element.setAttribute('style', 'background-color: ' + vm.buttonBackColor);
            }
          }, 500);
          clearInterval(scrollInterval);
        }
      }, 15);
    } else {
      console.log('Btn Confirm not found');
    }
  }

  public elementInViewport(el: any) {
    const rect = el.getBoundingClientRect();

    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /* or $(window).height() */
      rect.right <= (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */
    );
  }

  public handleConfirmChooseAppointment() {
    this.$router.push({
      name: 'contact-appointment',
      query: {
        appointmentId: this.getAppointmentClicked.toString(),
        ...this.$route.query
      }
    });
  }

  public getActiveClass(appointment: IAppointment) {
    if (this.getAppointmentClicked == appointment.AppointmentID) {
      return 'btn-active';
    }
    return '';
  }
}
